import { ButtonProps } from "@/types/buttonProps";
import { CircularProgress } from "@mui/material";
import "./styles.scss";


export default function ButtonCustom(props: ButtonProps) {
  function handleEnter(event: any) {
    if (event.key === "Enter") {
      props.onClick()
    }
  }

  return (
    <button
      type={props.type}
      disabled={props.disabled || props.loading}
      className={`initial-pattern ${props?.className}`}
      onClick={props.onClick}
      onKeyDown={handleEnter}
      ref={props.ref}
    >
      <div>
        {props.iconName && !props.showRightIcon && !props.loading ? (
          <span className={`material-symbols-outlined ${props.classNameIconName || ""}`}>{props.iconName}</span>
        ) : (
          <>
            {props.loading && !props.showRightIcon && (
              <CircularProgress className="!w-5 !h-auto" />
            )}
          </>
        )}

        {!props.loading && <p className={props.classNameLabel}>{props.label}</p>}

        {props.iconName && props.showRightIcon && !props.loading ? (
          <span className={`material-symbols-outlined ${props.classNameIconName || ""}`}>{props.iconName}</span>
        ) : (
          <>
            {props.loading && props.showRightIcon && (
              <CircularProgress className="!w-5 !h-auto" />
            )}
          </>
        )}
      </div>
    </button>
  );
}
